<template>
  <v-card outlined>
    <v-card-title>
      <h2>Sign up or log in</h2>
    </v-card-title>
    <v-card-text>

      <GoogleAuth :userType="userType" :redirectRouteName="redirectRouteName" />

      <v-divider />
      <h3 class="mt-5 text-center">
        Or continue with Email
      </h3>
      <v-btn-toggle borderless class="d-flex flex-wrap justify-space-around py-5">

        <v-btn id="show-email-login" large @click="showLoginForm">
          <v-icon left>email</v-icon>
          <span class="font-weight-black">I have an account</span>
        </v-btn>

        <v-btn id="show-email-signup" large @click="showSignupForm">
          <v-icon left>email</v-icon>
          <span class="font-weight-black">Create an account</span>
        </v-btn>

      </v-btn-toggle>

      <SignupForm v-if="signupFormVisible" :userType="userType" :redirectRouteName="redirectRouteName"></SignupForm>
      <LoginForm v-if="loginFormVisible" :userType="userType" :redirectRouteName="redirectRouteName"></LoginForm>
    </v-card-text>
  </v-card>
</template>


<script>
import SignupForm from './SignupForm'
import LoginForm from './LoginForm'
import GoogleAuth from './GoogleAuth'

export default {
  name: 'AuthOptions',
  props: ['userType', 'redirectRouteName'],
  components: {
    SignupForm, LoginForm, GoogleAuth
  },
  data() {
    return {
      signupFormVisible: false,
      loginFormVisible: false
    }
  },
  methods: {
    showSignupForm() {
        this.signupFormVisible = true
        this.loginFormVisible = false
    },
    showLoginForm() {
        this.loginFormVisible = true
        this.signupFormVisible = false
    }
  }
}
</script>